"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var FormErrors = /** @class */ (function (_super) {
    __extends(FormErrors, _super);
    function FormErrors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormErrors.prototype.render = function () {
        return this.props.form && this.props.form.errors && this.props.form.errors.length ? (React.createElement("div", { className: (this.props.className ? this.props.className + " " : "") + "flex flex-col justify-center text-red" }, this.props.form.errors.map(function (error, i) { return (React.createElement("div", { className: "flex flex-row items-start" + (i != 0 ? " mt-0-8" : "") },
            React.createElement(Snippets.Svg, { name: "info", width: 20, className: "block" }),
            React.createElement(Snippets.RichText, { className: "ml-0-4 text-xs mt-0-1 block flex-1", size: "tiny" }, error.message))); }))) : this.props.errors ? (React.createElement("div", { className: (this.props.className ? this.props.className + " " : "") + "flex items-center text-red" },
            React.createElement(Snippets.Svg, { name: "info", width: 20 }),
            React.createElement(Snippets.RichText, { className: "ml-0-4 text-xs mt-0-1", size: "tiny" }, this.props.errors))) : null;
    };
    return FormErrors;
}(React.PureComponent));
exports.FormErrors = FormErrors;
